import React from 'react';
import '../style/loading.css'; // Importamos o CSS

const LoadingOverlay = ({ loading }) => {
    if (!loading) return null; // Se não estiver carregando, não renderiza nada
    return (
        <div className="loading-overlay">
            <div className="loading-content">
                <div className="spinner"></div>
                <span>Carregando...</span>
            </div>
        </div>
    );
};

export default LoadingOverlay;
